import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import AccessTimeFilledRoundedIcon from '@mui/icons-material/AccessTimeFilledRounded';
import CancelPresentationRoundedIcon from '@mui/icons-material/CancelPresentationRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import api from '../api/api';
import Toast from '../global/toastmessage'
import { useDispatch } from 'react-redux';
import { setUserDetails } from '../redux/userSlice';

const FieldLogin = ({ onClose }) => {
  const [phone, setPhone] = useState('');
  const [showPin, setShowPin] = useState(false);
  const [pin, setPin] = useState(['', '', '', '']);
  const navigate = useNavigate();
  const dispatch=useDispatch()
   const [toast, setToast] = useState({
      open: false,
      message: '',
      severity: 'success' 
    });
  
    const showToast = (message, severity = 'success') => {
      setToast({
        open: true,
        message,
        severity
      });
    };
  
    const handleCloseToast = () => {
      setToast(prev => ({ ...prev, open: false }));
    };

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const formattedTime = currentDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/New_York',
  });

  const handlePhoneSubmit = async (e) => {
    e.preventDefault(); 
    try {
      const response = await api.get(`/auth/mobile_number/${phone}`);
      if (response.status === 200) {
        setShowPin(true);
      }
      if (response.status === 201) {
        showToast(
          response.message || 'Phone Not Found',
          'error' // <- This ensures the toast shows as error (usually red)
        )}}
     catch (error) {
      alert('User not found!');
      showToast(error.response.data?.message);

    }
  };

  const handlePinChange = (index, value) => {
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);
    if (value && index < 3) {
      document.getElementById(`pin-${index + 1}`).focus();
    }
  };

  const handlePinSubmit = async () => {
    const enteredPin = pin.join('');
    try {
      const response = await api.post('/auth/validatePin', { phonenumber: phone, mpin: enteredPin });
    
    
        if (response.status === 200) {
          console.log(response)
          sessionStorage.setItem('accessToken', response?.access_token);
          sessionStorage.setItem('role', response.data[0]?.user_roles?.role);
          sessionStorage.setItem('userid', response?.id);          
          dispatch(setUserDetails(response?.data[0]))
          navigate('/dashboard');
        }  
      else if (response.status === 201) {
        showToast(
          response.message || 'Enter Correct Pin',
          'error'
        );
      }
    }
    catch (error) {
      alert('Invalid PIN!');
      showToast(error.response.data?.message);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex h-screen">
      {/* Left Panel */}
      <div className="w-[30%] bg-[#faf0f0] flex flex-col justify-start items-center p-8">
        <div className="flex flex-col items-center mb-4">
          <div className="flex items-center my-2">
            <CalendarTodayRoundedIcon className="mr-2" />
            <span>{formattedDate}</span>
          </div>
          <div className="flex items-center my-2">
            <AccessTimeFilledRoundedIcon className="mr-2" />
            <span>{formattedTime}</span>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-[70%] bg-white flex flex-col justify-start items-center p-8 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-black">
          <ClearRoundedIcon />
        </button>

        <h1 className="text-2xl font-semibold mb-6 mr-auto">
          {showPin ? 'Enter 4-digit PIN' : 'Enter Registered Phone Number'}
        </h1>

        {!showPin ? (
          <>
            <input
              type="tel"
              placeholder="Enter Phone"
              maxLength="10"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-4 py-3 mb-6 mr-auto focus:shadow-[0_0_6px_1px_#145388] focus:outline-none"
            />
            <button
            type="button"
              onClick={handlePhoneSubmit}
              className="bg-[#145388] w-full text-white text-lg px-8 py-3 mr-auto rounded-full hover:bg-blue-700 transition-colors"
            >
              Continue
            </button>
          </>
        ) : (
          <>
            <div className="flex space-x-4 mb-6">
              {pin.map((digit, index) => (
                <input
                  key={index}
                  id={`pin-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handlePinChange(index, e.target.value.replace(/\D/, ''))}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace') {
                      if (pin[index]) {
                        // Just clear the current input
                        handlePinChange(index, '');
                      } else if (index > 0) {
                        // Move to previous input and clear it
                        document.getElementById(`pin-${index - 1}`).focus();
                        handlePinChange(index - 1, '');
                      }
                    }
                  }}
                  className="w-12 h-12 text-xl text-center border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              ))}
            </div>
            <button
              onClick={handlePinSubmit}
              className="bg-[#145388] w-full text-white text-lg px-8 py-3 rounded-full hover:bg-blue-700 transition-colors"
            >
              Continue
            </button>
          </>
        )}
      </div>
      <Toast
          open={toast.open}
          onClose={handleCloseToast}
          severity={toast.severity}
          message={toast.message}
        />
    </div>
  );
};

export default FieldLogin;
